const translations = {
  general: {
    documentTitle: "Rechercher des voitures d'occasion",
  },
  compare: {
    back: 'Retour',
    searchMore: "Trouver plus de voitures d'occasion",
    pageTitle: "Comparer les voitures d'occasion",
    photo: 'Photo',
    emptyState: {
      title: 'Aucun véhicule sélectionné',
      desc: 'Aucun véhicule n\'a (encore) été sélectionné pour être comparé. Trouvez un véhicule et cliquez sur "Comparer" pour l\'ajouter.',
      button: "Rechercher des voitures d'occasion",
    },
  },
  vehicle: {
    mileageUnit: 'km',
    energyPowerUnit: 'kW',
    horsePowerUnit: 'CH',
    type: 'Version',
    vehicleType: 'Type de véhicule',
    price: 'Prix',
    year: 'Année de construction',
    mileage: 'Kilométrage',
    fuelType: 'Carburant',
    enginePower: 'Puissance',
    transmission: 'Transmission',
    license: "Plaque d'immatriculation",
    body: 'Carrosserie',
    numberDoors: 'Nombre de portes',
    lining: 'Tapisserie',
    color: 'Couleur extérieure',
    numberCilinders: 'Quantité de cylindres',
    sizes: 'Des mesures',
    engineCapacity: 'Cylindrée',
    engineVolume: 'Capacité moteur',
    engineCapacityUnit: 'cc',
    weight: 'Lester',
    maxTowingWeight: 'Max. poids de traction',
    weightUnit: 'kg',
    volumeUnit: 'L',
    fuelConsumption: 'Consommation aux {amount} km',
    taxMargin: 'TVA/Marge',
    btwMarge: 'TVA/Marge',
    energyLabel: "Classe d'efficacité énergétique",
    roadTax: 'Taxe routière',
    perQuarterEstimation: 'trimestre (estimation)',
    inclTax: 'TVA incluse',
    exclTax: 'hors TVA',
    finance: {
      from: 'à partir de',
      privateLeaseFrom: 'Bail privé à partir de',
      perMonth: 'p/mois',
    },
    actions: {
      offer: 'Citation requise',
      tradeIn: 'Calculez votre valeur de reprise',
      privateLease: 'Demander un bail privé',
      finance: 'Demande de financement',
      testDrive: 'Demander un essai routier',
      callMeBack: 'Rappelle-moi',
      buy: 'Acheter maintenant',
      compare: 'Comparer',
      appointment: 'Prendre rendez-vous',
      print: 'Imprimer ce véhicule',
    },
    warranties: {
      napCheck: 'Vérification NAP',
      hundredPercentMaintained: '100% maintenu',
      carPass: 'Car-Pass',
      bovagDescription:
        "Selon le forfait de livraison choisi, les garanties suivantes peuvent être fournies avec le véhicule. Contactez-nous pour plus d'informations sur les forfaits de livraison spécifiques.",
      bovag40: 'Contrôle BOVAG 40 points',
      bovagAfleverbeurt: 'Livraison BOVAG',
      bovag6months: '6 mois de garantie BOVAG',
      bovag12months: '12 mois de garantie BOVAG',
      bovag24months: '24 mois de garantie BOVAG',
      autotrust: 'Autotrust',
      vakgarant: 'Vakgarant',
      vweOccasionPlan: 'VWE Occasion Garant Plan',
      cargarantie: 'Cargarantie',
      additionalWarrantyButton: 'Consultez nos conditions de garantie',
    },
  },
  loop: {
    view: 'Voir la voiture',
    viewCar: 'Voir',
    compare: 'Comparer',
  },
  single: {
    back: "Retour à toutes les voitures d'occasion",
    contactTitle: 'Contact direct',
    shareTitle: 'Partager cette voiture',
    shareText: 'Voir%20cette%20voiture%20sur%20',
    route: 'La Route',
    email: 'E-mail',
    tabs: {
      specs: 'Caractéristiques',
      options: 'Choix',
      desc: 'Description',
      warranty: 'Garantie',
      deliverOptions: 'Colis de livraison',
    },
    deliverOptions: {
      description: 'Description',
      price: 'Prix',
      inclTax: 'TVA incluse',
      contents: 'Capacité',
    },
    warranty: {
      moreInfo: "Plus d'information",
    },
  },
  filters: {
    title: "Rechercher des voitures d'occasion",
    modalTitle: 'Configurer des filtres de recherche',
    modalButton: 'Voir les résultats',
    compare: 'Comparer',
    filter: 'Filtres',
    allBrands: 'Toutes les marques',
    allModels: 'Tous les modèles',
    brand: 'Marque',
    model: 'Modéle',
    resetFilters: 'Effacer les filtres',
    emptyState: {
      title: "Rien n'a été trouvé",
      desc: "Nous n'avons trouvé aucun véhicule correspondant aux critères spécifiés. Ajustez les filtres ou cliquez sur le bouton pour recommencer.",
      button: 'Réinitialiser tous les filtres',
    },
    results: '{count} résultat | {count} résultats',
  },
  search: {
    inputTitle: 'Terme de recherche',
    inputPlaceholder: 'Chercher...',
    searchIn: 'Recherche dans',
    searchInAll: 'Tous les véhicules',
    searchInSelection: 'Véhicules de la sélection',
    submit: 'Chercher',
  },
  sort: {
    relevance: 'Pertinence',
    alphabetically: 'Alphabétiquement',
    priceAsc: 'Prix ​​(bas - haut)',
    priceDesc: 'Prix ​​(haut - bas)',
    dateAddedDesc: "Date d'ajout (nouveau - ancien)",
    mileageAsc: 'Kilométrage (bas - haut)',
  },
  forms: {
    noTranslationAvailable:
      "Malheureusement, cette partie du site Web ne peut pas être servie dans votre langue. Veuillez nous contacter si vous avez besoin d'aide.",
    errors: {
      requiredFields: 'Remplissez tous les champs obligatoires',
      requiredFieldSingle: 'Ce champ est requis',
      acceptTerms: 'Vous devez accepter les conditions',
      validEmail: "S'il vous plaît, mettez une adresse email valide",
      noAddressFound: {
        text: "L'adresse n'a pas pu être trouvée. Avez-vous entré le code postal et le numéro de maison corrects ?",
        button: 'Remplir manuellement',
      },
      somethingWentWrong: "Une erreur s'est produite lors de l'envoi de la demande. Réessayez plus tard.",
    },
    fields: {
      salutation: 'Salutation',
      salutationMale: 'M.',
      salutationFemale: 'Mme.',
      fullName: 'Nom et prénom',
      name: 'Nom',
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      email: 'Adresse e-mail',
      phone: 'Numéro de téléphone',
      address: 'Adresse',
      zip: 'Code postal',
      houseNumber: 'Numéro de maison',
      houseNumberSupplement: 'Ajout',
      city: 'Ville',
      street: 'Nom de rue',
      birthDate: 'Date de naissance',
      mileage: 'Kilométrage',
      comments: 'Commentaires',
      acceptTermsPre: "Je suis d'accord avec le",
      terms: 'termes et conditions',
      unknown: 'Inconnue',
      submitRequest: 'Confirmer la requête',
      yes: 'Oui',
      no: 'Non',
      companyName: "Nom de l'entreprise",
    },
    testRide: {
      title: 'Demander un essai routier',
      preferenceDate: "Date d'essai préférée",
      submit: 'Demander un essai routier',
    },
    appointment: {
      title: 'Prendre rendez-vous',
      preferenceDate: "Date d'approbation du flux",
      preferenceTime: 'Heure préférée',
      submit: 'Prendre un rendez-vous',
    },
    tradeIn: {
      title: 'Calculer la valeur de reprise',
    },
    privateLease: {
      title: 'Demander un bail privé',
      stepCalculator: 'Votre bail privé',
      stepPersonalDetails: 'Les données',
      stepConfirm: 'Confirmer',
      leaseAmount: 'Montant du bail',
      from: 'à partir de',
      perMonth: 'par mois',
      calculationDisclaimer: "sur la base de {mileage} km par an et d'une durée de contrat de {duration} mois",
      calculatorTitle: 'Rédigez votre bail privé',
      calculatorDesc:
        'Le montant du bail dépend de plusieurs facteurs. Demandez un devis ici et découvrez votre montant de location personnel par mois.',
      duration: 'Durée souhaitée',
      months: 'mois',
      mileagePerYear: 'Kilomètres par an',
      damageFreeYears: "Nombre d'années sans sinistre",
      prepayment: 'Verser',
      request: 'Demander',
      toConfirmStep: 'Confirmer',
      confirmDesc:
        'Vérifiez vos coordonnées ici, puis confirmez la candidature pour la soumettre. Nous vous contacterons dès que possible.',
      leaseDetails: 'Détails du bail',
      personalDetails: 'Les données',
      edit: 'modifier',
    },
    callMeBack: {
      title: 'Rappelle-moi',
      submit: 'Rappelle-moi',
    },
    finance: {
      title: 'Calculer le financement',
      consumer: 'Privée',
      business: 'Business',
      vehiclePrice: "Prix ​​d'achat du véhicule",
      prepaymentTradeIn: 'Dépôt / reprise',
      creditSumLoanAmount: 'Montant du crédit / montant du prêt',
      durationInMonths: 'Durée en mois',
      finalSum: 'Conclusion',
      finalSumError: 'Pas de conclusion possible, le montant minimum à financer est de',
      monthlyFee: 'Montant mensuel',
      calculationDisclaimer: "Le calcul est basé sur un {interestRate}% taux d'intérêt effectif annuel.",
      askOffer: 'Citation requise',
      stepCalculator: 'Votre financement',
      stepPersonalDetails: 'Informations personnelles',
      stepConfirm: 'Confirmer',
      financeDetails: 'Détails du financement',
      confirmDesc:
        'Vérifiez vos coordonnées ici, puis confirmez la candidature pour la soumettre. Nous vous contacterons dès que possible.',
    },
    offer: {
      title: 'Citation requise',
      tradeInCar: 'Vous souhaitez échanger une voiture?',
      yourLicense: "Votre plaque d'immatriculation",
      submit: 'Citation requise',
    },
    buy: {
      title: 'Achetez cette voiture en ligne',
      stepPersonalDetails: 'Les données',
      stepPaymentDelivery: 'Paiement & Livraison',
      stepConfirm: 'Confirmer',
      personalDetailsDesc:
        'Avez-vous trouvé la voiture de vos rêves? Magnifique! Entrez vos coordonnées ci-dessous pour finaliser la commande.',
      consumerOrBusiness: "S'agit-il d'une commande privée ou professionnelle?",
      consumer: 'Privée',
      business: 'Business',
      ownerQuestion: 'Au nom de qui la voiture doit-elle être immatriculée?',
      ownerSelf: 'Mon propre nom',
      ownerOther: 'Autre nom',
      ownerDetails: 'Attribution',
      driverLicenseCountry: 'Avez-vous un permis de conduire néerlandais ou étranger?',
      dutch: 'Néerlandais',
      foreign: 'Étranger',
      driverLicenseDisclaimer:
        "Nous avons besoin de votre numéro de permis de conduire et de votre date de naissance pour l'attribution (immatriculation) de la voiture. Numéro de permis de conduire pas à portée de main? Pas de problème, nous vous contacterons avant la livraison de la voiture.",
      driverLicenseNumber: 'Numéro de permis de conduire',
      toPaymentDetails: 'Mode de paiement',
      paymentDetails: 'Mode de paiement',
      paymentDetailsDesc: "Comment souhaitez-vous payer, à la livraison ou à l'avance?",
      paymentAtDelivery: 'Payer à la livraison',
      paymentAtDeliveryDesc: 'Vous payez via les services bancaires en ligne lorsque la voiture est livrée.',
      ideal: 'Demande de paiement',
      idealDesc: 'Vous payez facilement et en toute sécurité avec un lien que vous recevrez par e-mail.',
      bankTransfer: 'Virement',
      bankTransferDesc: 'Vous payez manuellement par virement bancaire, vous recevrez les détails du paiement par e-mail.',
      delivery: 'Livraison',
      deliveryDesc:
        'Choisissez ici si vous souhaitez faire livrer la voiture à votre domicile ou la récupérer chez nous. Indiquez ensuite une date de livraison souhaitée, nous vous contacterons pour la confirmer.',
      deliveryPackages: 'Paquet de livraison',
      deliveryPackagesDesc: 'Veuillez indiquer ci-dessous quel colis de livraison vous souhaitez inclure avec votre achat.',
      home_delivery: 'Faites-vous livrer à domicile',
      roadside_assistance: 'Assistance routière',
      insurance: 'Assurance',
      extraOptions: 'Options supplémentaires',
      extraOptionsDesc: "Ajoutez des options supplémentaires lors de l'achat de votre voiture d'occasion.",
      preferredDeliveryDate: 'Date de livraison souhaitée',
      toConfirm: 'Confirmer',
      confirmDesc: 'Après avoir vérifié vos coordonnées, vous pouvez soumettre la demande. Nous vous contacterons dès que possible.',
      personalDetails: 'Les données',
      edit: 'modifier',
    },
  },
}

export default translations
